import React, { forwardRef, useState, useEffect, useImperativeHandle } from 'react'
import { StatusCellComponent } from '../../../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import { getFormatedDate } from '../../../../unAssigned/concessionApproval/common';
import NoRowOverlay from '../../../../masters/holidayMaster/NoRowOverlay';
import { gridComponents, gridStyles } from '../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { AGridColDef } from '../../../../common/data-grid/ADataGridColDef';
import ADataGrid from '../../../../common/data-grid/ADataGrid';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { GridRowModes } from '@mui/x-data-grid';
import { ActionsCellComponent } from '../../../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import { getFormattedDate } from 'views/pages/manage/edpOps/constant/batch-search';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import { editCellContainerStyle } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { newRow } from './constant';
import { generateRandomId } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import ALoader from 'views/pages/manage/common/a-loader';
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import MultiSelectCellComponentWithSearch from 'views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch';
import WarningDialoge from '../WarningDialog';


const CscMappingListing = ({
    businessAreaDropdown = [],
    rows = [],
    createUpdateHandler,
    loading,
    currentPage,
    totalRecords,
    pageChangeHandler,
    dropdowns,
    deleteHandler,
    setDropdowns
}, ref) => {

    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});
    const [isOpen, setOpen] = useState(false)


    const rowFormHandler = (value, key) =>
        setRowForm((prev) => ({ ...prev, [key]: value }));

    useEffect(() => {
        setRowData(rows);
    }, [rows]);


    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit, fieldToFocus: "financeInstitution" },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };
    const handleDeleteClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            if(rowData.length==1){
               setOpen(params?.row)
            }
            else
            deleteHandler(params?.row)
        }
    }

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const handleSaveClick = async (params) => {
        createUpdateHandler(rowForm);
    };

    const addNewRow = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let randomId = generateRandomId();
            let emptyRow = {
                ...newRow,
                isNew: true,
                id: randomId,
            };
            startEditing(randomId, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };

    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
    }));

    const columns = [
        new AGridColDef('academicCareer', 'Career', false)
            .setMinWidth(110)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.academicCareer}
                        handleChange={value => {
                            // rowFormHandler(value, 'academicCareer');
                            setRowForm((prev) => ({ ...prev, 'academicCareer': value, 'examType': [] }))
                        }}
                        items={dropdowns?.academicCareer}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),

        new AGridColDef('academicStream', 'Stream', false)
            .setMinWidth(110)
            .setFlex(0.5)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.academicStream}
                        handleChange={value => {
                            rowFormHandler(value, 'academicStream');
                        }}
                        items={dropdowns?.academicStream}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef('academicClass', 'Class', false)
            .setMinWidth(80)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.academicClass}
                        handleChange={value => {
                            rowFormHandler(value, 'academicClass');
                        }}
                        items={dropdowns?.academicClass}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef('examType', 'Exam Type', false)
            .setMinWidth(110)
            .setFlex(0.8)
            .editable(true)
            .renderCellComponent((params) => (
                <MultiSelectCellComponentWithSearch
                    title={"Exam Type"}
                    data={params?.value}
                    eyeIcon
                />
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.examType}
                        handleChange={value => {
                            rowFormHandler(value, 'examType');
                        }}
                        items={rowForm?.academicCareer?.label == 'PRO' ?
                            dropdowns?.examType.filter(item => item?.label == 'IAT'):
                            ['HYB','RCC'].includes(rowForm?.academicCareer?.label)?
                             dropdowns?.examType: dropdowns?.examType.filter(item => item?.label != 'IAT')
                            }
                        isMulti={true}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        isShowCount={true}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef('cscId', 'ID', false)
            .setMinWidth(120)
            .setFlex(1)
            .editable(false)
            .setValueGetter(params => params?.value)
        ,
        new AGridColDef('actions', 'Action', false)
            .setMinWidth(100)
            .setFlex(1)
            .editable(true)
            // .pinColumnLast(true)
            .columnAlign('right')
            .renderCellComponent(params =>
                <ActionsCellComponent
                    mode={'view'}
                    handleEditClick={handleEditClick}
                    handleSaveClick={handleSaveClick}
                    handleCancelClick={handleCancelClick}
                    handleDeleteClick={handleDeleteClick}
                    icon={true}
                    cancelIcon={true}
                    deleteIcon={true}
                    params={params}
                    customEditIcon
                />
            )
            .renderEditCellComponent(params => (
                <ActionsCellComponent
                    mode={'edit'}
                    handleSaveClick={handleSaveClick}
                    handleCancelClick={handleCancelClick}
                    handleDeleteClick={handleDeleteClick}
                    icon={true}
                    cancelIcon={<CancelIcon
                        className="mx-2 cursor"
                        onClick={() => handleCancelClick(params)}
                    />}
                    deleteIcon={true}
                    params={params}
                    isSaveDisabled={!(rowForm?.academicCareer && rowForm?.academicStream && rowForm?.academicClass && rowForm?.examType && rowForm?.examType.length > 0)}
                />
            )),

    ]

    return (
        <>
            {loading && <ALoader position='fixed' />}
            <ADataGrid
                removeWrapperContainer
                rowModesModel={rowModesModel}
                rows={rowData || []}
                columns={columns}
                rowId={(row) => row.id}
                rowHeight={50}
                loading={false}
                rowCount={totalRecords}
                nextButtonHandler={pageChangeHandler}
                currentPage={currentPage}
                hidePagination
                components={{
                    ...gridComponents,
                    NoRowsOverlay: () => (
                        <NoRowOverlay message={loading ? "Loading..." : null} />
                    ),
                }}
                sx={gridStyles}
                autoHeight
            // pinLastColumn
            />

             <WarningDialoge
                isOpen={isOpen}
                setOpen={setOpen}
                handleOkay={()=>{deleteHandler(isOpen); setOpen(false)}}
                subheading={'Deleting all CSC mappings will deactivate this Business Area on the website. Are you sure you want to proceed?'}
                
            />
        </>
    );
}

export default forwardRef(CscMappingListing);